import { IQueryTypeFragments } from '../../QueryFragments';
import { QueryType } from '../Default';

const productTimeOfUseFragment = `
    on ${QueryType.product} {
        time_of_use {
            key
            value
        }
    }
`;

export const productTimeOfUseFragments = (): IQueryTypeFragments => {
    return {
        [QueryType.product]: productTimeOfUseFragment
    };
};
